<router-outlet></router-outlet>

<div *ngIf="infoLoading.requestingData$ | async as loadingMsg" class="info-loader">
  <img
    class="loader"
    height="98px"
    width="auto"
    src="https://images.ergo-plus.com/ergoplus-loader-small.gif"
    alt="ergoPlusLogo"
  />
  <h3>{{ loadingMsg }}</h3>
</div>
